import { render, staticRenderFns } from "./UploadPagePlaceholder.vue?vue&type=template&id=53ea18a4&scoped=true&"
import script from "./UploadPagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./UploadPagePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./UploadPagePlaceholder.vue?vue&type=style&index=0&id=53ea18a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea18a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
